import logo from './logo.svg';
import './App.css';
import Navbar from "./Navbar";
import Square from "./Square";
import {useEffect, useState} from 'react';
import GameBanner from "./GameBanner";

function App() {
    // letter used state
    const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

    const initialKeyStatus = LETTERS.reduce((acc, letter) => {
        acc[letter] = ''; // could be '', 'correct', 'present', 'absent'
        return acc;
    }, {});
    const KEYBOARD_ROWS = [
        ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
        ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'],
        [ '✅','Z', 'X', 'C', 'V', 'B', 'N', 'M', '←']
    ];

    const [keyStatuses, setKeyStatuses] = useState(initialKeyStatus);
    const [indexStatuses, setIndexStatuses] = useState([['','', '', '', '', '']
        , ['', '', '', '', '', ''], ['', '', '', '', '', ''], ['', '', '', '', '', ''], ['', '', '', '', '', ''], ['', '', '', '', '', '']]);
    const updateKeyStatus = (letter, newStatus) => {
        setKeyStatuses(prev => {
            const current = prev[letter];

            // Priority: correct > present > absent > ''
            const priority = { '': 0, absent: 1, present: 2, correct: 3 };

            if (priority[newStatus] > priority[current]) {
                return { ...prev, [letter]: newStatus };
            }

            return prev;
        });
    };
    const ANSWER = 'NIGGER';
    const NUM_ROWS = 6;
    const WORD_LENGTH = 6;

    const [board, setBoard] = useState(
        Array(NUM_ROWS).fill().map(() => Array(WORD_LENGTH).fill(''))
    );
    const [currentRow, setCurrentRow] = useState(0);
    const [currentCol, setCurrentCol] = useState(0);
    const [isGameOver, setIsGameOver] = useState(false);
    const [isGameWon, setIsGameWon] = useState(false);
    const restartGame = () => {
        setBoard(Array(NUM_ROWS).fill().map(() => Array(WORD_LENGTH).fill('')));
        setCurrentRow(0);
        setCurrentCol(0);
        setIsGameOver(false);
        setIsGameWon(false);
        setKeyStatuses(initialKeyStatus);
        setIndexStatuses(Array(NUM_ROWS).fill().map(() => Array(WORD_LENGTH).fill('')));
    };
    const handleVirtualKey = (key) => {
        if(key==="✅"){
            key = 'Enter'
        }
        const upperKey = key.toUpperCase();

        if (/^[A-Z]$/.test(upperKey) && currentCol < WORD_LENGTH) {
            const newBoard = [...board];
            newBoard[currentRow][currentCol] = upperKey;
            setBoard(newBoard);
            setCurrentCol((prev) => prev + 1);
        } else if ((key === '←' || key === 'Backspace') && currentCol > 0) {
            const newBoard = [...board];
            newBoard[currentRow][currentCol - 1] = '';
            setBoard(newBoard);
            setCurrentCol((prev) => prev - 1);
        } else if (key === 'Enter' && currentCol === WORD_LENGTH) {
            const guess = board[currentRow].join('');
            console.log('Submitting guess:', guess);

            const newIndexStatuses = [...indexStatuses];
            const answerCopy = ANSWER.split('');

            for (let i = 0; i < WORD_LENGTH; i++) {
                let newStatus = '';
                if (guess[i] === ANSWER[i]) {
                    newStatus = 'correct';
                    newIndexStatuses[currentRow][i] = 'correct';
                    answerCopy[i] = null;
                } else if (answerCopy.includes(guess[i])) {
                    newStatus = 'present';
                    newIndexStatuses[currentRow][i] = 'present';
                    answerCopy[answerCopy.indexOf(guess[i])] = null;
                }
                updateKeyStatus(guess[i], newStatus);
            }

            setIndexStatuses(newIndexStatuses);
            setCurrentRow((prev) => prev + 1);
            setCurrentCol(0);

            if (guess === ANSWER) {
                setIsGameWon(true);
            } else if (currentRow === NUM_ROWS - 1) {
                setIsGameOver(true);
            }
        }
    };

    useEffect(() => {
        const handleKeyDown = (event) => {
            const key = event.key.toUpperCase();

            if (/^[A-Z]$/.test(key) && currentCol < WORD_LENGTH) {
                // Type a letter
                const newBoard = [...board];
                newBoard[currentRow][currentCol] = key;
                setBoard(newBoard);
                setCurrentCol((prev) => prev + 1);
            } else if (event.key === 'Backspace' && currentCol > 0) {
                // Delete a letter
                const newBoard = [...board];
                newBoard[currentRow][currentCol - 1] = '';
                setBoard(newBoard);
                setCurrentCol((prev) => prev - 1);
            } else if (event.key === 'Enter' && currentCol === WORD_LENGTH) {
                // Submit guess
                console.log('Submitting guess:', board[currentRow].join(''));
                setCurrentRow((prev) => prev + 1);
                setCurrentCol(0);
                const guess = board[currentRow].join('');
                // if letter is in guess but in wrong place make it 'present'
                const newStatuses = {...keyStatuses};
                const newIndexStatuses = [...indexStatuses];
                let answerCopy = ANSWER.split('');
                // First pass: Check for correct letters
                for (let i = 0; i < WORD_LENGTH; i++) {
                    let newStatus= ''
                    if (guess[i] === ANSWER[i]) {
                        newStatus = 'correct';
                        newStatuses[guess[i]] = 'correct';
                        newIndexStatuses[currentRow][i] = 'correct';
                        answerCopy[i] = null; // Mark as used
                    }
                    if (guess[i] !== ANSWER[i] && answerCopy.includes(guess[i])) {
                        newStatus = 'present';
                        newStatuses[guess[i]] = 'present';
                        newIndexStatuses[currentRow][i] = 'present';
                        answerCopy[answerCopy.indexOf(guess[i])] = null; // Mark as used
                    }
                    updateKeyStatus(guess[i],newStatus);

                }
                console.log('New key statuses:', keyStatuses)

                setIndexStatuses(newIndexStatuses);
                console.log('New statuses:', newStatuses);
                if (guess === ANSWER) {
                    setIsGameWon(true);
                } else if (currentRow === NUM_ROWS - 1) {
                    setIsGameOver(true);
                }

            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [board, currentRow, currentCol]);

    return (
    <div className="App">
        <Navbar/>
        {isGameWon && (
            <GameBanner
                message="You Win! Congratulations you Racist"
                onRestart={restartGame}
            />
        )}

        {isGameOver && !isGameWon && (
            <GameBanner
                message="Game Over"
                reveal={ANSWER}
                onRestart={restartGame}
            />
        )}


        <div className="grid">
            {board.map((row, rowIndex) => (
                <div className="row" key={rowIndex}>
                    {row.map((letter, colIndex) => (
                        <Square key={colIndex} letter={letter} status={indexStatuses[rowIndex][colIndex]}/>
                    ))}
                </div>
            ))}
        </div>


        <div className="board">
            {KEYBOARD_ROWS.map((row, rowIndex) => (
                <div className="row" key={rowIndex}>
                    {row.map((key) => (
                        <Square
                            key={key}
                            letter={key}
                            type="keyboard"
                            status={keyStatuses[key] || ''}
                            onClick={() => handleVirtualKey(key)}
                        />

                    ))}
                </div>
            ))}
        </div>
    </div>
  );
}

export default App;
